import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";

import {AddPage as AddProductPage} from '../application-products/pages/AddPage';
import {EditPage as EditProductPage} from '../application-products/pages/EditPage';


export const ApplicationsLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListApplications} redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path='add'
                element={
                    <RequirePermission action={rbacActions.CreateApplication} redirectTo='/applications'>
                        <AddPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetApplication} redirectTo='/applications'>
                        <EditPage/>
                    </RequirePermission>
                }

            >
            </Route>

            <Route
                path=':id/products/add'
                element={
                    <RequirePermission action={rbacActions.CreateApplicationProduct} redirectTo='/applications'>
                        <AddProductPage/>
                    </RequirePermission>
                }

            >
            </Route>

            <Route
                path=':id/products/:applicationProductId'
                element={
                    <RequirePermission action={rbacActions.UpdateApplicationProduct} redirectTo='/applications'>
                        <EditProductPage/>
                    </RequirePermission>
                }

            >
            </Route>

        </Routes>
    );
};
